var _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _g, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 36,
    viewBox: "0 0 26 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_992_8522)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3545 20.8325L13.3262 22.5482L7.29164 33.0003L5.55961 29.1375L10.3545 20.8325Z",
    fill: "#CE4444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3545 20.8325L7.38282 19.1168L1.34829 29.5689L5.55961 29.1375L10.3545 20.8325Z",
    fill: "#983535"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5938 20.8325L11.6221 22.5482L17.6566 33.0003L19.3886 29.1375L14.5938 20.8325Z",
    fill: "#983535"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5938 20.8325L17.5654 19.1168L23.6 29.5689L19.3886 29.1375L14.5938 20.8325Z",
    fill: "#CE4444"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3823,
    cy: 13.6357,
    r: 10.321,
    fill: "url(#paint0_linear_992_8522)",
    stroke: "#765C00",
    strokeWidth: 0.180268
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3826,
    cy: 13.6356,
    r: 7.98615,
    fill: "#A88300"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_992_8522",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 6,
    width: 17,
    height: 17
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.8084,
    cy: 14.4881,
    r: 8.00474,
    fill: "#C28B37"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_992_8522)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.3817,
    cy: 13.6356,
    r: 8.00474,
    fill: "#C09525"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4263 8.06689L14.153 11.5204L17.6065 11.952L15.2351 14.6112L15.8798 18.4273L12.4263 16.7006L8.97283 18.4273L9.62323 14.6112L7.24609 11.952L10.6996 11.5204L12.4263 8.06689Z",
    fill: "url(#paint1_linear_992_8522)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.48993 7.43354L3.6158 4.95569L2.48993 2.47785L4.96777 3.60372L7.44562 2.47785L6.31975 4.95569L7.44562 7.43354L4.96777 6.30767L2.48993 7.43354Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_992_8522",
    x: 1.20739,
    y: 2.33679,
    width: 24.5108,
    height: 32.7823,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.988676,
    dy: 0.988676
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.564958
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_992_8522"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_992_8522",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_992_8522",
    x1: 12.3823,
    y1: 3.40479,
    x2: 12.3823,
    y2: 23.8666,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDE69"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_992_8522",
    x1: 12.4263,
    y1: 8.06689,
    x2: 12.4263,
    y2: 18.4273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFCDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE896"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldIcon);
export default __webpack_public_path__ + "static/media/goldIcon.9eb927137ded90cdeeb6c8a89f2b8b8d.svg";
export { ForwardRef as ReactComponent };